export default __webpack_public_path__ + "static/media/head9.68ec0bcd.svg";